import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <TopicsSection />
        <CardsSection />
        <AppSection />
        <ContactSection />
        <FeaturesSection />
        <CarouselSection />
        <UpdatesSection />
        <IndexSection />
        <AboutSection />
        <CommentsSection />
        <RankingSection />
        <MediaSection />
        <FaqSection />
      </main>

      <Footer />
    </div>
  );
}